import React, { Component } from "react";
import { Icon, Row, Select } from "antd";
import debounce from "lodash/debounce";
import { PropTypes } from 'prop-types';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import guideStarLogo from "../../../../assets/icons/GuideStar-logo.svg";
import { agreementCityLoader, agreementCitySearched, agreementCountyLoader, agreementCountySearched } from '../../../../Epics/Grants/Pages/GrantAgreement/actions';
// grants dashoard actions
import { grantCityLoader, grantCitySearched, grantCountyLoader, grantCountySearched } from '../../../../Epics/Grants/Pages/GrantsDashboard/actions';
import { cityLoader, citySearched, countyLoader, countySearched } from "../../../../Epics/Grants/Pages/RecommendGrant/actions";
import { InputWrapper } from "../../../../Epics/NPA/Pages/Step1Setup/styles";
import { CustomSelectBox, InputField } from '../../../commonStyles';
import Preloader from "../../../Preloader/Preloader";
import { Box } from "../../styles";
import { States } from "./data";
import { MsA } from "./msa";
import { BottomWrapper, CloseText, FilterCol, PoweredBy, SelectBox, TabTitles } from "./styles";
import { recordError } from "../../../../utils/commonUtil";
import { geoGraphyDerivedStates } from "../../../selectors";
const Option = Select.Option;

const ConfigGeo = [
  {
    title: "State",
    mode: "multiple",
    placeholder: "Filter by state",
    key: "state",
    options: "stateOptions",
    filterSet: false
  },


  {
    title: "City",
    mode: "multiple",
    placeholder: "Filter by City",
    key: "city",
    options: "zipRaOptions",
    filterSet: false
  },
  {
    title: "Zipcode",
    mode: "multiple",
    placeholder: "Filter by zip code",
    key: "zip",
    options: "zipCodeOptions",
    filterSet: false
  },
  {
    title: "Zipcode Radius",
    mode: "default",
    placeholder: "Filter by zip code radius",
    key: "radius",
    options: "zipRaOptions",
    filterSet: false
  },
  {
    title: "County",
    mode: "multiple",
    placeholder: "Filter by county",
    key: "county",
    options: "zipRaOptions",
    filterSet: false
  }
];

const zipRadius = [
  { name: "5 miles", miles: 5 },
  { name: "10 miles", miles: 10 },
  { name: "25 miles", miles: 25 },
  { name: "50 miles", miles: 50 }
];


export const stateOp =  States.map((obj, index) => {
    return (
      <Option key={obj.name} value={obj.name} title={obj.name}>
        {obj.name}
      </Option>
    );
  });



  export const msaOp =  MsA.map((obj, index) => {
    return (
      <Option key={obj.name} value={obj.name} title={obj.name}>
        {obj.name}
      </Option>
    );
  });




  export const zipRaOp  =   zipRadius.map((obj, index) => {
     return (
      <Option key={obj.miles} value={obj.name} title={obj.name}>
        {obj.name}
      </Option>
    );
  });


const children = [];
for (let i = 10; i < 36; i++) {
  children.push(<Option key={i.toString(36) + i}>{i.toString(36) + i}</Option>);
}

export class Geography extends Component {
  constructor(props) {
    super(props);
    this.lastFetchId = 0;
    this.lastFetchCountyId = 0;
    this.fetchUser = debounce(this.fetchUser, 2000);
    this.fetchCountyUser = debounce(this.fetchCountyUser, 2000);

  }

  state = {
    stateOptions: stateOp,
    zipOptions: zipRaOp,
    zipRaOptions: zipRaOp,
    menuIsOpen: false,
    data: [],
    countyData: [],
    value: [],
    countyValue: [],
    fetching: false,
    countyFetching: false,
    filterCityProps: [],
    inputValue: "",
    zipRadiusVal: "",
    zipRadiusMiles: "",
  };

  stateChange = (value, id) => {
    if (id === 'radius') {
      if (!value) {
        value = 0
        this.props.updateStateFunc(value, id);
      } else {
        let zipRadValue = zipRadius.filter(function (item) {
          if (value === item.name) { return item.miles }
        });
        this.props.updateStateFunc(zipRadValue[0]?.miles, id);
      }

    } else {
      this.props.updateStateFunc(value, id);
    }


  };

  closeFunc = index => {
    try {
      this.props.closeOption(index);
    } catch (error) {
      recordError(error);
    }
  };

  fetchUser = value => {
    switch (this.props.fromPage) {
      case 'GD':
        this.props.grantCityLoader();
        break;
      case 'GA':
        this.props.agreementCityLoader();
        break;
      case 'RAG':
      default:
        this.props.cityLoader();
        break;
    }
    this.lastFetchId += 1;
    this.setState({ data: [], fetching: true }, this.postCityData(value));
  };
  fetchCountyUser = value => {
    switch (this.props.fromPage) {
      case 'GD':
        this.props.grantCountyLoader();
        break;
      case 'GA':
        this.props.agreementCountyLoader();
      case 'RAG':
      default:
        this.props.countyLoader();
        break;
    }
    this.lastFetchCountyId += 1;
    this.setState({ countyData: [], countyFetching: true }, this.postCountyData(value));
  };

  postCityData = value => {
    const fetchId = this.lastFetchId;
    switch (this.props.fromPage) {
      case 'GD':
        this.props.grantCitySearched({
          method: 'GET',
          url: `/api-search-city/${value}`,
          data: { body: value },
          page: 'grantsDashboard',
          isExternal: true
        })
        break;
      case 'GA':
        this.props.agreementCitySearched({
          method: 'GET',
          url: `/api-search-city/${value}`,
          data: { body: value },
          page: 'grantAgreements',
          isExternal: true
        })
      case 'RAG':
      default:
        this.props.citySearched({
          method: 'GET',
          url: `/api-search-city/${value}`,
          data: { body: value },
          page: 'recommendGrant',
          isExternal: true
        });
        break;
    }
    this.setState({ fetching: true });
  };

  postCountyData = value => {
    const fetchId = this.lastFetchCountyId;
    switch (this.props.fromPage) {
      case 'GD':
        this.props.grantCountySearched({
          method: 'GET',
          url: `/api-search-county/${value}`,
          data: { body: value },
          page: 'grantsDashboard',
          isExternal: true
        });
        break;
      case 'GA':
        this.props.agreementCountySearched({
          method: 'GET',
          url: `/api-search-county/${value}`,
          data: { body: value },
          page: 'grantAgreements',
          isExternal: true
        });
      case 'RAG':
      default:
        this.props.countySearched({
          method: 'GET',
          url: `/api-search-county/${value}`,
          data: { body: value },
          page: 'recommendGrant',
          isExternal: true
        });
        break;
    }
    this.setState({ countyFetching: true });
  };


  handleChange = (value, id) => {
    let cityArr = value.map((item) => (item.label))
    this.props.updateStateFunc(cityArr, id);
    this.setState({
      value,
      data: [],
      fetching: false
    });
  };
  handleClick = (e) => {
    if (this.node?.contains(e.target)) {
      return
    }
    let elem = document.querySelector('.GeoPopup');
    if(elem) elem.style.display = 'none';
  }

  handleCountyChange = (countyValue, id) => {
    let countyArr = countyValue.map((item) => (item))
    this.props.updateStateFunc(countyArr, id);
    this.setState({
      countyValue,
      countyData: [],
      countyFetching: false
    });
  };

  onFocusUser = (value) => {
    if (!value) {
      this.setState({ data: [] })
    }
  }
  onFocusCounty = (value) => {
    if (!value) {
      this.setState({ countyData: [] })
    }
  }

  stateFocusChange = (value, id) => {
    this.setState({ inputValue: value.target.value })
    if (id === 'zip') {
      this.props.updateStateFunc(value.target.value, id);
    }
  }

  componentWillMount() {
    // Removed document listener due to unintended side effect - bug 6637
    // document.addEventListener('mousedown', this.handleClick, false)
    if (this.props.tabFilters.radius !== "") {
      this.setState({ zipRadiusMiles: this.props.tabFilters.radius + " miles" })
    } else {
      this.setState({ zipRadiusMiles: undefined })
    }
    this.setState({value:this.props.tabFilters.city,
                  countyValue:this.props.tabFilters.county})
  }

  componentWillReceiveProps(nextprops) {
    if (nextprops.tabFilters.radius) {
      const zipRadiusMiles = zipRadius.filter(function (item) {
        if (nextprops.tabFilters.radius === item.miles) { return item.name }
      });
      this.setState({ zipRadiusMiles: zipRadiusMiles[0].name })
    } else { this.setState({ zipRadiusMiles: undefined }) }

    if (nextprops.tabFilters.radius === 0) {
      this.setState({ zipRadiusMiles: '' })
    }

    this.setState({ inputValue: nextprops.tabFilters.zip })
    if (nextprops.tabFilters.city.length === 0) {
      this.setState({
        value: []
      })
    }
    if (nextprops.tabFilters.county.length === 0) {
      this.setState({
        countyValue: []
      })
    }
    if (nextprops !== this.props)
      if (nextprops.searchCity) {
        const data = nextprops.searchCity.map((user, index) => ({
          text: `${user.name}`,
          value: index
        }));
        this.setState({ data, fetching: false });
      }
    if (nextprops.searchCounty) {
      const countyData = nextprops.searchCounty.map((user, index) => ({
        text: `${user.name}`,
        value: index
      }));
      this.setState({ countyData, countyFetching: false });
    }
  }

  render() {
    const { fetching, data, value, countyFetching, countyData, countyValue } = this.state;
    const { isLoading, isFull } = this.props;
    return (
      <Box className="GeoPopup" ref={node => this.node = node} left={isFull ? 70 : 62.5}>
        <Row gutter={16} >
          {ConfigGeo.map((obj, index) => {
            const dummystate = obj.key;
            const childrenData = obj.options;
            return (
              <FilterCol id="area" className="gutter-row" lg={{ span: 8 }}>
                <TabTitles>{obj.title} </TabTitles>
                {index === 1 ? (
                  <CustomSelectBox
                    id="selFilterByCity"
                    value={this.props.tabFilters[dummystate]}
                    mode="multiple"
                    labelInValue
                    showArrow
                    value={value}
                    placeholder="Filter by city"
                    notFoundContent={fetching ? <Preloader /> : null}
                    filterOption={false}
                    onSearch={this.fetchUser}
                    onChange={event => this.handleChange(event, obj.key)}
                    onFocus={this.onFocusUser}
                    dropdownClassName="advisorSel"
                    width={isFull ? "300" : "220"}
                    getPopupContainer={() => document.getElementById('area')}
                  >
                    {data.map(d => (
                      <Option value={d.value} title={d.text}>{d.text}</Option>
                    ))}
                  </CustomSelectBox>
                ) : index === 4 ?
                    (<CustomSelectBox
                      id="selFilterByCountry"
                      value={this.props.tabFilters[dummystate]}
                      mode="multiple"
                      labelInValue
                      showArrow
                      value={countyValue}
                      placeholder="Filter by county"
                      notFoundContent={countyFetching ? <Preloader /> : null}
                      filterOption={false}
                      onSearch={this.fetchCountyUser}
                      onChange={event => this.handleCountyChange(event, obj.key)}
                      onFocus={this.onFocusCounty}
                      dropdownClassName="advisorSel"
                      width={isFull ? "300" : "220"}
                      getPopupContainer={() => document.getElementById('area')}

                    >
                      {countyData.map(d => (
                        <Option key={d.value} title={d.text}>{d.text}</Option>
                      ))}
                    </CustomSelectBox>)
                    : index === 2 ?
                      (
                      <InputWrapper paddingHorizontal="8px">
                        <InputField
                          id="txtFilterByZipcode"
                          value={this.props.tabFilters[dummystate]}
                          onChange={event => this.stateFocusChange(event, obj.key)}
                          key={obj.key}
                          width={isFull ? "300" : "180"}
                          placeholder={obj.placeholder}
                          type="number"
                        />

                      </InputWrapper>
                      
                      ) : index === 3 ? (
                        <SelectBox
                          id="selFilterByZipcodeRadius"
                          value={this.props.tabFilters[dummystate] === 0 ? undefined : this.state.zipRadiusMiles}
                          showArrow
                          allowClear={true}
                          mode={obj.mode}
                          width={isFull ? "370" : "290"}
                          placeholder={obj.placeholder}
                          onChange={event => this.stateChange(event, obj.key)}
                          key={obj.key}
                          dropdownClassName="advisorSel"
                          getPopupContainer={() => document.getElementById('area')}
                        >
                          {this.state[childrenData]}
                        </SelectBox>
                      ) : (<CustomSelectBox
                            id="selFilterByState"
                            value={this.props.tabFilters[dummystate]}
                            showArrow
                            mode={obj.mode}
                            dropdownClassName="advisorSel"
                            width={isFull ? "300" : "220"}
                            placeholder={obj.placeholder}
                            onChange={event => this.stateChange(event, obj.key)}
                            key={obj.key}
                            getPopupContainer={() => document.getElementById('area')}
                          >
                            {this.state[childrenData]}
                          </CustomSelectBox>)}
              </FilterCol>
            );
          })}

        </Row>
        <Row>
          <BottomWrapper>
            <PoweredBy>
              <span>Powered By</span>
              <img src={guideStarLogo} alt="Vangaurd" />
            </PoweredBy>
            <CloseText
              id="anrCloseGeography"
              key="closeText"
              onClick={index => this.closeFunc(this.props.index)}
            >
              Close <Icon type="close" />
            </CloseText>
          </BottomWrapper>
        </Row>
      </Box>
    );
  }
}

const mapStateToProps = state => ({
  ...geoGraphyDerivedStates(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  citySearched: data => dispatch(citySearched(data)),
  cityLoader: () => dispatch(cityLoader()),
  countySearched: data => dispatch(countySearched(data)),
  countyLoader: () => dispatch(countyLoader()),
  // grants dashboard actions
  grantCitySearched: data => dispatch(grantCitySearched(data)),
  grantCityLoader: () => dispatch(grantCityLoader()),
  grantCountySearched: data => dispatch(grantCountySearched(data)),
  grantCountyLoader: () => dispatch(grantCountyLoader()),
  //grant agreement
  agreementCitySearched: data => dispatch(agreementCitySearched(data)),
  agreementCityLoader: () => dispatch(agreementCityLoader()),
  agreementCountySearched: data => dispatch(agreementCountySearched(data)),
  agreementCountyLoader: () => dispatch(agreementCountyLoader())
});

Geography.propTypes = {
  agreementCityLoader: PropTypes.func,
  agreementCitySearched: PropTypes.func,
  agreementCountyLoader: PropTypes.func,
  agreementCountySearched: PropTypes.func,
  cityLoader: PropTypes.func,
  citySearched: PropTypes.func,
  closeOption: PropTypes.func,
  countyLoader: PropTypes.func,
  countySearched: PropTypes.func,
  fromPage: PropTypes.string,
  geminiFilterData: PropTypes.func,
  grantCityLoader: PropTypes.func,
  grantCitySearched: PropTypes.func,
  grantCountyLoader: PropTypes.func,
  grantCountySearched: PropTypes.func,
  history: PropTypes.object,
  index: PropTypes.number,
  isCountyLoading: PropTypes.bool,
  isFull: PropTypes.bool,
  isLoading: PropTypes.bool,
  location: PropTypes.object,
  match: PropTypes.object,
  searchCity: PropTypes.any,
  searchCounty: PropTypes.any,
  sliderStatus: PropTypes.func,
  staticContext: PropTypes.any,
  tabFilters: PropTypes.shape({
    city: PropTypes.array,
    county: PropTypes.array,
    msa: PropTypes.array,
    radius: PropTypes.number,
    state: PropTypes.array,
    zip: PropTypes.string,
  }),
  updateStateFunc: PropTypes.func,
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Geography)
);
